/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ folder: NonNullable<unknown> }} Canvas_File_Write_Grant_BodyInputs */



/**
* | output |
* | --- |
* | "Allow it to add files to the folder “{folder}”?" |
*
* @param {Canvas_File_Write_Grant_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_file_write_grant_body = /** @type {((inputs: Canvas_File_Write_Grant_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_File_Write_Grant_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Erlauben, dass sie Dateien im Ordner „${i?.folder}“ ablegt?`)
	return /** @type {LocalizedString} */ (`Allow it to add files to the folder “${i?.folder}”?`)
});